var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14457_107919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37321 5.37321 0 12 0C18.6268 0 24 5.37321 24 12C24 18.6268 18.6268 24 12 24C5.37321 24 0 18.6268 0 12ZM2.03571 12C2.03571 17.5018 6.49821 21.9643 12 21.9643C17.5018 21.9643 21.9643 17.5018 21.9643 12C21.9643 6.49821 17.5018 2.03571 12 2.03571C6.49821 2.03571 2.03571 6.49821 2.03571 12ZM11.0904 17.6234C10.8493 17.3823 10.7139 17.0553 10.7139 16.7143C10.7139 16.3733 10.8493 16.0463 11.0904 15.8051C11.3316 15.564 11.6586 15.4286 11.9996 15.4286C12.3406 15.4286 12.6676 15.564 12.9087 15.8051C13.1498 16.0463 13.2853 16.3733 13.2853 16.7143C13.2853 17.0553 13.1498 17.3823 12.9087 17.6234C12.6676 17.8645 12.3406 18 11.9996 18C11.6586 18 11.3316 17.8645 11.0904 17.6234ZM12.6424 13.7143H11.3567C11.2389 13.7143 11.1424 13.6179 11.1424 13.5V6.21429C11.1424 6.09643 11.2389 6 11.3567 6H12.6424C12.7603 6 12.8567 6.09643 12.8567 6.21429V13.5C12.8567 13.6179 12.7603 13.7143 12.6424 13.7143Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14457_107919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.826fa251722d6c7a54fac4012c11fe0d.svg";
export { ForwardRef as ReactComponent };